module.exports = __webpack_public_path__ + "static/media/alert-modal-success.886a28f8.svg";